import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  button: {
    justifyContent: "center !important",
  },
}));

export default useStyle;
